export const marginY = 6;

export const spacingBreakpoint = 1120;
